
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { getStorage } from 'firebase/storage';
import { getDatabase } from 'firebase/database';
import { getFirestore } from 'firebase/firestore/lite';


const firebaseConfig = {
  apiKey: "AIzaSyBP9CZClWuaQWKjuxUhH4iuXPSY0VKvyho",
  authDomain: "temi-general-db.firebaseapp.com",
  projectId: "temi-general-db",
  storageBucket: "temi-general-db.appspot.com",
  messagingSenderId: "516817311469",
  appId: "1:516817311469:web:380113e280ac4f703f1ee4",
  /* 
  during setup of realtime database, if you choose another region different from us-central,
  you need to add databaseURL to the firebaseConfig
  */
  databaseURL: "https://temi-general-db-default-rtdb.europe-west1.firebasedatabase.app"
};





const app = initializeApp(firebaseConfig);
export const auth = getAuth();
const provider = new GoogleAuthProvider();
/* export const db = async () => {
  return await getDatabase(app)
}; */
export const storage = getStorage(app);

export const db = getDatabase();
export const signInWithGoogle = () => signInWithPopup(auth, provider);